import ReactGA from 'react-ga'
import React from 'react'
import * as column from './columns'
import moment from 'moment'
import { Table, DatePicker, Alert } from 'antd'
import Graph from './Graph'
import {
  fetchWorkshopMaintenanceRecords,
  subscribeFulcrumRefresh,
} from '../../utilities/fulcrumData'

class Maintenance extends React.Component {
  constructor() {
    super()
    this.state = {
      dateFrom: null,
      dateTo: null,
      workshop: [],
      loading: false,
      error: null,
    }
    this.loadCancelled = false
    this.unsubscribeRefresh = null
    this.dateSelectionUpdate = this.dateSelectionUpdate.bind(this)
  }

  componentDidMount() {
    ReactGA.pageview('/maintenance')
    this.unsubscribeRefresh = subscribeFulcrumRefresh(() => this.loadWorkshop())
    this.loadWorkshop()
  }

  componentWillUnmount() {
    this.loadCancelled = true
    if (this.unsubscribeRefresh) {
      this.unsubscribeRefresh()
    }
  }

  loadWorkshop() {
    const { dateFrom, dateTo } = this.state
    this.setState({ loading: true, error: null })

    fetchWorkshopMaintenanceRecords(dateFrom, dateTo)
      .then((workshop) => {
        if (!this.loadCancelled) {
          this.setState({ workshop, loading: false })
        }
      })
      .catch((err) => {
        if (!this.loadCancelled) {
          this.setState({ error: err, loading: false })
        }
      })
  }

  dateSelectionUpdate(dates, dateStrings) {
    if (!dates || !dates[0] || !dates[1]) {
      this.setState({ dateFrom: null, dateTo: null }, () => this.loadWorkshop())
      return
    }
    this.setState(
      {
        dateFrom: moment(dateStrings[0], 'DD-MM-YYYY').format('YYYY-MM-DD'),
        dateTo: moment(dateStrings[1], 'DD-MM-YYYY').format('YYYY-MM-DD'),
      },
      () => this.loadWorkshop()
    )
  }

  render() {
    const { workshop, loading, error, dateFrom, dateTo } = this.state
    const workshopData = []
    let countTruck = 0
    let countRig = 0
    let countPlant = 0
    let countVehicle = 0

    for (let i = 0; i < workshop.length; i++) {
      const record = workshop[i]
      const formValues = record.form_values || {}

      const descriptionParts = ['2bc1', '2cd7', '9bb8', '25ee', '36fa', '253d', '2871', '3394', 'c27d']
        .map((key) => (formValues[key] ? ` • ${formValues[key]}` : ''))
        .join('')

      let vehicle = ''
      const assetField = formValues['5b6b']
      if (assetField) {
        if (assetField.choice_values && assetField.choice_values[1]) {
          vehicle = assetField.choice_values[1]
        } else if (assetField.other_values && assetField.other_values[0]) {
          vehicle = assetField.other_values[0]
        }
        const assetType = assetField.choice_values && assetField.choice_values[0]
        if (assetType === 'Vehicle') countVehicle++
        if (assetType === 'Plant') countPlant++
        if (assetType === 'Rig') countRig++
        if (assetType === 'Truck') countTruck++
      }

      const completedByField = formValues.fdcd
      const completedBy =
        (completedByField && completedByField.choice_values && completedByField.choice_values[0]) ||
        (completedByField && completedByField.other_values && completedByField.other_values[0]) ||
        ''

      workshopData.push({
        id: record.id,
        date: formValues['4bc0'],
        description: descriptionParts,
        on: vehicle,
        completedBy,
      })
    }

    workshopData.sort((a, b) => (a.date > b.date ? -1 : 1))

    const datePickerValue =
      dateFrom && dateTo ? [moment(dateFrom), moment(dateTo)] : null

    return (
      <div>
        <h1>Maintenance</h1>
        <h4>
          All maintenance sheets are shown by default. Optionally filter by the sheet date below.
        </h4>
        <DatePicker.RangePicker
          allowClear
          ranges={{
            'Previous 10 Days': [moment().startOf('day').subtract(10, 'day'), moment()],
            'Previous 30 Days': [moment().startOf('day').subtract(30, 'day'), moment()],
            'This Year': [moment().startOf('year'), moment().endOf('year')],
          }}
          value={datePickerValue}
          format="DD-MM-YYYY"
          onChange={this.dateSelectionUpdate}
          style={{ padding: '20px 0' }}
        />
        {error ? (
          <Alert
            type="error"
            showIcon
            message="Could not load maintenance records"
            description={error.message || 'Please try again.'}
            style={{ marginBottom: 16 }}
          />
        ) : null}
        <h4>This graph shows the maintenance completed on specific categories.</h4>
        <Graph data={[countTruck, countRig, countPlant, countVehicle]} />
        <h1>Details</h1>
        <Table
          loading={loading}
          pagination={false}
          id="boresTableTwo"
          className="tableResizer"
          columns={column.workshopList}
          expandedRowRender={(record) => <p style={{ margin: 0 }}>{record.description}</p>}
          dataSource={workshopData}
          rowKey="id"
          size="small"
        />
      </div>
    )
  }
}

export default Maintenance
